import TprPartyAutoCompleteMasterField from './TprPartyAutoCompleteMasterField'

function TprPartyAutoCompleteField(props) {
    return TprPartyAutoCompleteMasterField(
      props
    )
  }
  
  export default TprPartyAutoCompleteField